export default "__VITE_ASSET__BTJ4k7_n__"